// removed by extract-text-webpack-plugin
module.exports = {"box":"_3m1oeg4_9kAFq7EHYYTJB4","padding":"_2jUMb4vjtZOpUXdArlP3IW","shadow":"_3B3V0qYB6QYzFZ3CCuMLZf"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/components/containers/Box.css
// module id = 205
// module chunks = 0